<div class="MainContainer animated fadeIn" style="overflow: hidden;">
    <div class="overlay" *ngIf="UpdateSearchResultsQuestion || ShowMergeProducts || ImportProductsQuestion || ProductsSearchOn || ShowDeleteProductQuestion || ShowProductHistoryEventsContainer"></div>

    <div class="PrePartnerSheetPopUp animated fadeInDown" *ngIf="ShowMergeProducts;">
      <div class="PopUpCloseContainer" (click)="ShowMergeProducts = false;">
        <i class="material-icons">close</i>
      </div>
      <div class="PopUpTitleContainer">
        <p>{{ 'MergeProducts' | translate }}</p>
      </div>
  
      <div class="PopUpBody">
        <div class="MainTitleBar" style="overflow: hidden;">
  
          <div class="MainTitleBarIconContainer">
            <i class="material-icons">merge</i>
          </div>
  
          <div class="FifteenPercentContainer">
            <mat-form-field style="width: 100%;" appearance="outline">
              <mat-label>{{ 'SelectTargetProduct' | translate }}</mat-label>
              <mat-select name="DecimalPrecision" [compareWith]="compareFn" [(ngModel)]="TargetProduct">
                <mat-option *ngFor="let p of this.SelectedProducts" [value]="p">
                  {{p.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
  
      <div class="PopUpCommands">
        <button
          [disabled]="!TargetProduct" mat-raised-button color="primary" matTooltip="{{'MergeProducts' | translate}}"
          class="PopGeneralCommandButton" (click)="MergeProducts();">{{'MergeProducts' | translate}}
        </button>
      </div>
    </div>

    <div class="ProductHistoryEventsContainer" *ngIf="ShowProductHistoryEventsContainer">
      <div class="PopUpCloseContainer" (click)="ShowProductHistoryEventsContainer = false;">
        <i class="material-icons">close</i>
      </div>

      <div class="PopUpTitleContainer">
        <p style="color: #0082e6;">{{ 'ProductEventHistory' | translate }}: [{{auxProduct.Name}}] {{auxProduct.Name}}</p>
       </div>

       <div class="PopUpBody" style="margin-top: 20px;">
        <div class="ProductHistoryRow" *ngFor="let e of this.ProductEvents; let i=index;">
          <p style="color: #0082e6;">{{e.DisplayValue}} : {{e.EventRegisterUI}}</p>
          <p style="color: #aaa;">{{'Receptions.Administration' | translate}}: {{auxProduct.Administration.Name}}</p>
          <p *ngIf="e.GeneralDocType != null;">{{'DocQuantity' | translate}}: {{e.AbsDocQuantity}}</p>
          <p *ngIf="e.GeneralDocType != null;">{{'DocumentType' | translate}}: <span style="color:#32aa3a;">{{e.GeneralDocType?.Name}}</span></p>
          <p *ngIf="e.Discrepancy > 0;">{{'Discrepancy' | translate}}: <span style="color: red;">{{e.Discrepancy}}</span> / {{'StockQuantity' | translate}}: <span style="color: red;">{{e.AbsStockQuantity}}</span></p>
          <p>{{'CurrentQuantity' | translate}}: <span [ngClass]="{'positiveQty': e.FinalQuantity > 0, 'negativeQty' : e.FinalQuantity < 0 }">{{e.FinalQuantity}}</span></p>
        </div>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteProductQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowDeleteProductQuestion = false; currentProductToDelete = null;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>

      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteProductQuestion = false; currentProductToDelete = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteProductQuestion = false;DeleteProduct(currentProductToDelete.ID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="UpdateSearchResultsQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="UpdateSearchResultsQuestion = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'UpdateSearchResultsQuestionQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'UpdateSearchResultsQuestionDescription' | translate }}
      </div>

      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="UpdateSearchResultsQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="accent" class="InfoQuestionButton" (click)="UpdateSearchResultsQuestion = false; UpdateProductsSearchResults();">{{ 'UpdateSearchResults' | translate }}</button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ImportProductsQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ImportProductsQuestion = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'ImportProductsQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'ImportProductsQuestionDescription' | translate }}
      </div>

      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ImportProductsQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="accent" class="InfoQuestionButton" (click)="ImportProductsQuestion = false; ImportProductsFromConnectedService('FoxlineAutomotiveOCProductsImport');">{{ 'Import' | translate }}</button>
      </div>
    </div>

    <div class="MainTitleBar" style="width: 100%;margin-left: 0%;margin-right: 0%;margin-bottom: 0;">

      <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" style="margin-left: 1%;padding-top: 5px;width: 10%">
        <mat-label>{{ 'ProductGeneralType' | translate }}</mat-label>
        <mat-select name="ProductGeneralType" [compareWith]="compareFirst" [(ngModel)]="ProductGeneralType">
          <mat-option *ngFor="let a of this.masterData.ProductGeneralTypes;" [value]="a" (click)="SearchProducts(true);">
            {{a.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" style="margin-left: 1%;padding-top: 5px;width: 10%;">
        <mat-label>{{ 'Receptions.Administration' | translate }}</mat-label>
        <mat-select name="Administration" [compareWith]="compareFirst" [(ngModel)]="Administration">
          <mat-option *ngFor="let a of this.masterData.Administrations;" [value]="a" (click)="SearchProducts(true);">
            {{a.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

        <mat-form-field class="ProductsSearchBox" appearance="outline" style="margin-left: 1px;padding-top: 5px;">
            <mat-label>{{'SearchProducts' | translate}}</mat-label>
            <i class="material-icons SearchIcon" *ngIf="SearchTerm == ''">search</i>
            <input matInput type="text" [(ngModel)]="SearchTerm" (change)="SearchProducts();" (keydown.enter)="SearchProducts();">
            <button *ngIf="SearchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="SearchTerm=''">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <div class="FilterButtonContainer">
            <button mat-raised-button class="FilterButton" color="primary" (click)="SearchProducts();">
              <i class="material-icons">filter_alt</i>
              {{'Filter' | translate}}
            </button>

            <button mat-raised-button class="FilterButton" color="accent" style="margin-left: 1%;" (click)="ImportProductsQuestion = true;">
              <i class="material-icons">downloading</i>
              {{'Import' | translate}}
            </button>

            <div style="width: 100%;">
              <button mat-raised-button class="FilterButton" color="accent" style="margin-left: 1%;" (click)="UpdateSearchResultsQuestion = true;">
                <i class="material-icons">search</i>
                {{'UpdateSearchResults' | translate}}
              </button>
            </div>

          </div>

          <div class="TotalDocCountContainer">
            <span style="float: right;">{{this.Products.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'Products' | translate}} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.Filter.Pager.Pages}})</span>
            <div class="PageSizeContainer">
              <mat-form-field appearance="outline" class="PageSizeTextBox">
                <mat-label>{{ 'PageSize' | translate }}*</mat-label>
                <input matInput autocomplete="off" [(ngModel)]="Filter.Pager.PageSize" (change)="SearchProducts(false);">
              </mat-form-field>
            </div>
          </div>
  
          <div class="TotalDocCountContainer">
            <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="this.Filter.Pager.PageIndex = this.Filter.Pager.PageIndex - 1;SearchProducts(false);">
              <i class="material-icons">chevron_left</i>
            </div>
            <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
              <i class="material-icons">chevron_left</i>
            </div>
  
            <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="this.Filter.Pager.PageIndex = this.Filter.Pager.PageIndex + 1;SearchProducts(false);">
              <i class="material-icons">chevron_right</i>
            </div>
            <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
              <i class="material-icons">chevron_right</i>
            </div>
          </div>

          <button mat-raised-button class="MergeProductsButton" color="primary" *ngIf="SelectedItems > 0;" (click)="ShowMergeProducts = true;">
            <i class="material-icons">keyboard_double_arrow_right</i>
            {{'MergeProducts' | translate}}
          </button>
    </div>

    <div class="ProductsTableRow ProductsTableHeadder">
      <div class="ProductsCol" style="padding-left: 15px;text-align: left;width: 5%;">
        {{'Receptions.Table.Nr' | translate}}
      </div>
      <div class="ProductsCol" style="padding-left: 30px;text-align: left;width: 5%;">
        <mat-checkbox class="example-margin" [(ngModel)]="AllSelected" (change)="SelectAll();"></mat-checkbox>
      </div>
      <div class="ProductsCol" style="width: 15%;text-align: center;">
        {{ 'Receptions.Administration' | translate }}
      </div>
      <div class="ProductsCol" style="width: 33%;">
        {{ 'Receptions.Table.Name' | translate }}
      </div>
      <div class="ProductsCol" style="width: 20%;">
        {{ 'Receptions.Table.Code' | translate }}
      </div>
      <div class="ProductsCol">
        {{'StockValue' | translate}}
      </div>
      <div class="ProductsCol" style="width: 12%;">
        {{'Settings' | translate}}
      </div>
    </div>

    <div class="ProductsTableBody">
      <div class="overlayLocal" *ngIf="loadingSearchProducts"></div>
      <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="loadingSearchProducts"></mat-spinner>

      <div class="ProductsTableRow" *ngFor="let p of this.Products; let i=index;" (dblclick)="this.currentProduct = p;">
        <div class="ProductsCol" style="padding-left: 15px;text-align: left;width: 5%;">
          <p class="DottedRow">{{i + 1}}</p>
        </div>
        <div class="ProductsCol" style="padding-left: 30px;text-align: left;width: 5%;">
          <mat-checkbox class="example-margin" [(ngModel)]="p.IsSelected" (change)="UpdateNumberOfSelectedItems();"></mat-checkbox>
        </div>
        <div class="ProductsCol" style="width: 15%;text-align: center;">
          <p class="DottedRow">{{p.Administration.Name}}</p>
        </div>
        <div class="ProductsCol" style="width: 33%;">
          <p class="DottedRow" *ngIf="currentProduct?.ID != p.ID;">{{p.Name}}</p>
          <p class="DottedRow" *ngIf="currentProduct?.ID == p.ID;">
            <mat-form-field class="ProductRowInput" appearance="outline" style="margin-left: 1px;padding-top: 5px;">
              <mat-label>{{'Receptions.Table.Name' | translate}}</mat-label>
              <input matInput type="text" [(ngModel)]="p.Name">
            </mat-form-field>
          </p>
          <p class="SubInfoRow">{{'HOME.ProductType' | translate}}: <span style="font-weight: bold;letter-spacing: 1px;" [ngClass]="{'IsProduct': p.GeneralType.ID == 1, 'IsService': p.GeneralType.ID == 2, 'IsTax': p.GeneralType.ID == 3}">[{{p.GeneralType.Name}}]</span></p>
          <p class="SubInfoRow">{{'ProductID' | translate}}: <span style="font-weight: bold;color:#f60;">{{p.ID}}</span></p>
          <p class="SubInfoRow">{{'RegisterDate' | translate}}: <span style="font-weight: bold;color:#0082e6;">{{p.RegisteredUI}}</span></p>
        </div>
        <div class="ProductsCol" style="width: 20%;">
          <p class=" DottedRow" *ngIf="currentProduct?.ID != p.ID;">{{p.Code}}</p>
          <p class=" DottedRow" *ngIf="currentProduct?.ID == p.ID;">
            <mat-form-field class="ProductRowInput" appearance="outline" style="margin-left: 1px;padding-top: 5px;">
              <mat-label>{{'Receptions.Table.Code' | translate}}</mat-label>
              <input matInput type="text" [(ngModel)]="p.Code">
            </mat-form-field>
          </p>
        </div>
        <div class="ProductsCol">
          <p class="DottedRow">{{p.DiscrepancyAmmount}}</p>
        </div>
        <div class="ProductsCol" style="width: 12%;">
         <div *ngIf="currentProduct?.ID != p.ID;">
          <i class="material-icons ReceptionProductEdit" (click)="this.currentProduct = p;">edit</i>
          <i class="material-icons ReceptionProductEdit" style="color: #32aa3a;" (click)="GetProductHistoryEvents(p);">format_list_numbered</i>
          <i class="material-icons ReceptionProductEdit" style="color: red;" (click)="GetDeleteProductPossibility(p);">close</i>
         </div>
         <div *ngIf="currentProduct?.ID == p.ID;">
          <i class="material-icons ReceptionProductEdit" style="color: #32aa3a;" (click)="UpdateProduct(p);this.currentProduct = null;">check</i>
          <i class="material-icons ReceptionProductEdit" style="color: red;" (click)="this.currentProduct = null;">close</i>
         </div>
        </div>
      </div>
    </div>

</div>